import React, { useState, useEffect } from 'react';
import { FiCreditCard, FiSave, FiRefreshCw, FiUpload } from 'react-icons/fi';
import './Admin.css';

const UpdateQR = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [qrPreviews, setQrPreviews] = useState({});

  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/stores');
      if (response.ok) {
        const data = await response.json();
        setStores(data);
        // Fetch QR codes for each store
        data.forEach(store => fetchStoreQR(store.IDCH));
      } else {
        console.error('Failed to fetch stores');
      }
    } catch (error) {
      console.error('Error fetching stores:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStoreQR = async (storeId) => {
    try {
      const response = await fetch(`https://doticom.vn:3000/stores/${storeId}`);
      if (response.ok) {
        const store = await response.json();
        if (store.QRNganHang) {
          setQrPreviews(prev => ({
            ...prev,
            [storeId]: `data:image/jpeg;base64,${store.QRNganHang}`
          }));
        }
      }
    } catch (error) {
      console.error(`Error fetching QR for store ${storeId}:`, error);
    }
  };

  const handleFileChange = (storeId, event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setQrPreviews(prev => ({
          ...prev,
          [storeId]: e.target.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const updateStoreQR = async (storeId) => {
    const qrImage = qrPreviews[storeId];
    if (!qrImage) {
      alert('Vui lòng tải lên mã QR.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/update-qr-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: storeId, qrImage })
      });

      const result = await response.json();
      if (response.ok) {
        alert('Cập nhật mã QR thành công!');
      } else {
        alert(result.message || 'Có lỗi xảy ra');
      }
    } catch (error) {
      console.error('Error updating QR code:', error);
      alert('Có lỗi xảy ra khi cập nhật mã QR');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <div className="admin-main">
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiCreditCard size={32} color="#495057" />
              <div>
                <h1>Cập nhật mã QR</h1>
                <p>Quản lý mã QR thanh toán cho các cửa hàng</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button 
              className="btn btn-primary"
              onClick={fetchStores}
              disabled={loading}
            >
              <FiRefreshCw className={loading ? 'spinning' : ''} />
              {loading ? 'Đang tải...' : 'Làm mới'}
            </button>
          </div>
        </header>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Mã cửa hàng</th>
                        <th>Tên cửa hàng</th>
                        <th>Mã QR hiện tại</th>
                        <th>Tải lên mã QR mới</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stores.map(store => (
                        <tr key={store.IDCH}>
                          <td>{store.IDCH}</td>
                          <td>{store.MaPB}</td>
                          <td>{store.TenCuaHang}</td>
                          <td>
                            {qrPreviews[store.IDCH] ? (
                              <img 
                                src={qrPreviews[store.IDCH]} 
                                alt="QR Code"
                                style={{ 
                                  maxWidth: '100px', 
                                  maxHeight: '100px',
                                  border: '1px solid #ddd',
                                  borderRadius: '4px'
                                }}
                              />
                            ) : (
                              <span className="text-muted">Chưa có QR</span>
                            )}
                          </td>
                          <td>
                            <div className="d-flex flex-column gap-2">
                              <label className="btn btn-outline-primary btn-sm">
                                <FiUpload className="me-1" />
                                Chọn file
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{ display: 'none' }}
                                  onChange={(e) => handleFileChange(store.IDCH, e)}
                                />
                              </label>
                              {qrPreviews[store.IDCH] && (
                                <small className="text-success">✓ Đã chọn ảnh</small>
                              )}
                            </div>
                          </td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => updateStoreQR(store.IDCH)}
                              disabled={loading || !qrPreviews[store.IDCH]}
                            >
                              <FiSave className="me-1" />
                              Cập nhật
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateQR;
